import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography} from 'views/components';
import {Person, Mail, Phone, Home} from 'views/icons';
import {Translate} from 'views/module';

// The legacy Biography contact section without its Dialpad link, which writes to the legacy
// caregiver backend. The Loom caregiver page is read-only.
const LoomContactView = (props) => {
  const {bioQuestions, setIsComplete} = props;

  React.useEffect(() => {
    const requiredFields = [
      'firstName',
      'lastName',
      'email',
      'phoneNumber',
      'streetAddress',
      'city',
      'province',
      'postalCode',
    ];
    const isComplete = requiredFields.every((field) => bioQuestions[field] && String(bioQuestions[field]).trim() !== '');
    setIsComplete(isComplete);
  }, [bioQuestions]);

  const fullName = `${bioQuestions.firstName || ''} ${bioQuestions.lastName || ''}`.trim();
  const email = bioQuestions.email && String(bioQuestions.email).trim();
  const phoneNumber = bioQuestions.phoneNumber && String(bioQuestions.phoneNumber).trim();
  const address = [
    bioQuestions.streetAddress,
    bioQuestions.city,
    bioQuestions.province,
    bioQuestions.postalCode,
  ]
      .map((segment) => (typeof segment === 'string' ? segment.trim() : segment))
      .filter(Boolean)
      .join(', ');

  return (
    <Stack spacing={1}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Person size={20} />
        <Typography>
          {
            fullName ||
            <Translate expression="caregiver.CaregiverBiography.Contact.Missing.FullName" />
          }
        </Typography>
      </Stack>

      <Stack direction="row" alignItems="center" spacing={1}>
        <Mail size={20} />
        <Typography>
          {
            email ||
            <Translate expression="caregiver.CaregiverBiography.Contact.Missing.Email" />
          }
        </Typography>
      </Stack>

      <Stack direction="row" alignItems="center" spacing={1}>
        <Phone size={20} />
        <Typography>
          {
            phoneNumber ||
            <Translate expression="caregiver.CaregiverBiography.Contact.Missing.PhoneNumber" />
          }
        </Typography>
      </Stack>

      <Stack direction="row" alignItems="center" spacing={1}>
        <Home size={20} />
        <Typography>
          {
            address ||
            <Translate expression="caregiver.CaregiverBiography.Contact.Missing.Address" />
          }
        </Typography>
      </Stack>
    </Stack>
  );
};

LoomContactView.propTypes = {
  bioQuestions: PropTypes.object.isRequired,
  setIsComplete: PropTypes.func.isRequired,
};

export default React.memo(LoomContactView);
